import Toastr from 'toastr';


// const POSITION = 'toast-bottom-full-width';
const POSITION = 'toast-top-right';

export function success(text, onClick = () => {}, warningOptions){
   Toastr.options = {...warningOptions};
   Toastr.options.closeButton = true;
   Toastr.options.positionClass = POSITION;
   Toastr.success(text,null,{onclick: () => onClick()});
}

export function error(errorText, onClick = () => {}, warningOptions){
   Toastr.options = {...warningOptions};
   Toastr.options.closeButton = true;
   Toastr.options.positionClass = POSITION;
   Toastr.options.preventDuplicates = true;
   Toastr.options.onClick = () => onClick();
   Toastr.error(errorText,null,{onclick: () => onClick()});
   console.trace(errorText);
}


export function warning(warningText, onClick = () => {}, warningOptions){
   Toastr.options = {...warningOptions};
   Toastr.options.closeButton = true;
   Toastr.options.positionClass = POSITION;
   Toastr.options.onClick = () => onClick();
   Toastr.warning(warningText,null,{onclick: () => onClick()});
}
